export const proposalProvider = proposal => {
  const provider = String(
    proposal.banking_payload?.provider || proposal.product?.provider || ''
  )
    .toLowerCase()
    .replace(/^banking_/, '');
  return (
    {
      presenca: 'presenca_bank',
      hand: 'handplus',
      'hand+': 'handplus',
      banco_soma: 'soma',
    }[provider] || provider
  );
};

export const proposalProductLabel = proposal =>
  proposal.product?.name ||
  { clt: 'CLT', fgts: 'FGTS', inss: 'INSS' }[
    String(
      proposal.banking_payload?.product ||
        proposal.credit_payload?.product ||
        ''
    ).toLowerCase()
  ] ||
  'Produto não informado';

export const proposalHistory = proposal => {
  const events = Array.isArray(proposal.metadata?.timeline)
    ? proposal.metadata.timeline.filter(
        item => item && typeof item.message === 'string'
      )
    : [];
  if (events.length) return [...events].reverse();
  return proposal.created_at
    ? [
        {
          created_at: proposal.created_at,
          message:
            'Proposta registrada na Talkvia. Nenhuma atualização adicional no histórico.',
        },
      ]
    : [];
};
